import React, { useEffect, useState } from "react";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { GoClock } from "react-icons/go";
import { LuDot } from "react-icons/lu";
import { format, formatDistanceToNow } from "date-fns";
import ResponsiveHeader from "../reusble_components/labels3/responsiveHeader.jsx";
import { useStores } from "../../store/index.js";
import { useNavigate } from "react-router-dom";
import { Observer } from "mobx-react";
import OopsImage from "../../assests/oops.png";
import { MdPendingActions } from "react-icons/md";
import { BsCheckCircleFill } from "react-icons/bs";
import { IoMdCloseCircle } from "react-icons/io";
import { FaUserCheck } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";

const HistoryPage = () => {
  const applicationsPerPage = 9;
  const [page, setPage] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [previousRefresh, setPreviousRefresh] = useState(0);
  const { RecuiterStore } = useStores();
  const navigate = useNavigate();
  useEffect(() => {
    const skip = page * applicationsPerPage; // Calculate skip dynamically
    const limit = applicationsPerPage;

    if (
      RecuiterStore.jobApplications.length === 0 ||
      previousRefresh !== refresh
    ) {
      const body = {
        skip,
        limit,
      };

      RecuiterStore.fetchJobApplications(body);
      console.log(
        "pageCount",
        Math.ceil(RecuiterStore.applicationCount / applicationsPerPage)
      );
      setPreviousRefresh(refresh);
    }
  }, [refresh]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const oneWeekAgo = new Date(now.setDate(now.getDate() - 7));

    if (date > oneWeekAgo) {
      return formatDistanceToNow(date, { addSuffix: true });
    } else {
      return format(date, "MMM dd");
    }
  };

  const navigation = (id) => {
    // setSelectedId(id);
    if (window.innerWidth < 999) {
      return navigate(`/newone/${id}`);
    }
    return navigate(`/dashboard/myapplicants/${id}`);
  };

  return (
    <Observer>
      {() => (
        <>
          <div className="w-[94%] mx-auto mt-20 md:mt-3 lg:mt-3">
            <ResponsiveHeader
              title={"My Jobs"}
              showButton={false}
              showDropdown={false}
              searchPlaceHolder="Search your jobs"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  const body = {
                    search: e.target.value,
                  };
                  RecuiterStore.fetchJobApplications(body);
                }
              }}
            />
          </div>
          <div className="md:mt-6 mt-4 px-4 md:px-10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {RecuiterStore.jobApplications.length === 0 ? (
                <div className="col-span-full flex flex-col items-center justify-center py-12">
                  <img
                    src={OopsImage}
                    alt="Oops"
                    className="w-48 md:w-64 mb-6"
                  />
                  <button
                    className="px-6 py-2 text-white rounded-lg bg-primary hover:bg-primary/90 transition-colors"
                    onClick={() => navigate("/dashboard/jobinternship")}
                  >
                    Apply for job
                  </button>
                </div>
              ) : (
                RecuiterStore.jobApplications.map((job, index) => {
                  const formattedDate = formatDate(job?.createdAt);
                  const steps = [
                    { name: "Applied", value: true },
                    { name: "MCQ's", value: job?.mockTest ? true : false },
                    {
                      name: "Technical Interview",
                      value: job?.technicalInterview ? true : false,
                    },
                    {
                      name: "HR Interview",
                      value: job?.hrInterview ? true : false,
                    },
                  ];
                  return (
                    <div
                      key={index}
                      className="bg-white shadow-xl p-6 rounded-xl cursor-pointer hover:shadow-2xl transition-shadow"
                      style={{
                        boxShadow: "0px 10px 30px 0px rgba(0, 0, 0, 0.2)",
                      }}
                      onClick={() => navigation(job?._id)}
                    >
                      <div className="flex items-start space-x-4">
                        <img
                          src={
                            job?.recruiter?.pic ||
                            "https://img.freepik.com/premium-vector/building-logo-icon-design-template-vector_67715-555.jpg"
                          }
                          alt="Company Logo"
                          className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-lg"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://img.freepik.com/premium-vector/building-logo-icon-design-template-vector_67715-555.jpg";
                          }}
                        />
                        <div className="flex-1">
                          <div className="flex flex-col md:flex-row md:items-center gap-2">
                            <h2 className="text-sm md:text-base font-bold line-clamp-1">
                              {job?.jobPostId?.jobTitle}
                            </h2>
                            <div className="flex items-center text-xs gap-1">
                              <LuDot className="text-[#20BF55]" />
                              <span className="text-[#20BF55]">Active</span>
                            </div>
                          </div>
                          <p className="text-gray-500 text-xs md:text-sm py-1 line-clamp-1">
                            {job?.recruiter?.companyName}
                          </p>
                          <div className="flex flex-wrap gap-3 mt-1">
                            <div className="flex items-center gap-1 text-xs text-gray-500">
                              <MdLocationOn className="text-base" />
                              <span className="line-clamp-1">
                                {job?.jobPostId?.jobLocation || "Remote"}
                              </span>
                            </div>
                            <div className="flex items-center gap-1 text-xs text-gray-500">
                              <span className="line-clamp-1">
                                {job?.jobPostId?.salary?.minimum &&
                                job?.jobPostId?.salary?.maximum ? (
                                  <>
                                     ̰ ₹{" "}
                                    {job?.jobPostId?.salary?.minimum >= 100000
                                      ? `${
                                          job?.jobPostId?.salary?.minimum /
                                          100000
                                        }L`
                                      : job?.jobPostId?.salary?.minimum}{" "}
                                    - ₹{" "}
                                    {job?.jobPostId?.salary?.maximum >= 100000
                                      ? `${
                                          job?.jobPostId?.salary?.maximum /
                                          100000
                                        }L`
                                      : job?.jobPostId?.salary?.maximum}{" "}
                                  </>
                                ) : (
                                  <p> ₹ Not Disclosed </p>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-4">
                        {steps.map((step, index) => (
                          <div
                            key={index}
                            className="flex items-center gap-1 text-xs min-w-0"
                          >
                            <RiCheckboxCircleLine
                              className={`text-base flex-shrink-0 ${
                                step.value ? "text-primary" : "text-[#808080]"
                              }`}
                            />
                            <span
                              className={`truncate ${
                                step.value ? "text-black" : "text-[#808080]"
                              }`}
                            >
                              {step.name}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="mt-4 flex flex-row justify-between items-center gap-2">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${
                            job?.status === 0
                              ? "bg-amber-100 text-amber-700"
                              : job?.status === 1
                              ? "bg-blue-100 text-blue-700"
                              : job?.status === 2
                              ? "bg-red-100 text-red-700"
                              : job?.status === 3
                              ? "bg-green-100 text-green-700"
                              : "bg-gray-100 text-gray-700"
                          }`}
                        >
                          {job?.status === 0 ? (
                            <>
                              <MdPendingActions className="text-base" />
                              Pending
                            </>
                          ) : job?.status === 1 ? (
                            <>
                              <FaUserCheck className="text-base" />
                              Shortlisted
                            </>
                          ) : job?.status === 2 ? (
                            <>
                              <IoMdCloseCircle className="text-base" />
                              Rejected
                            </>
                          ) : job?.status === 3 ? (
                            <>
                              <BsCheckCircleFill className="text-base" />
                              Hired
                            </>
                          ) : null}
                        </span>
                        <div className="flex items-center gap-1 text-xs">
                          <GoClock className="text-slate-400" />
                          <p className="text-gray-500">
                            <span className="text-black">{formattedDate}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </>
      )}
    </Observer>
  );
};

export default HistoryPage;
